import {ContactMessageWrite, contactMessageWriteSchema, createContactMessageDb} from '@cp/model';
import {addDoc, serverTimestamp} from 'firebase/firestore';
import getContactMessageCollection from './getContactMessageCollection';

export async function submitContactMessage(data: ContactMessageWrite): Promise<{messageId: string}> {
  const parsed = contactMessageWriteSchema.parse(data);
  const col = getContactMessageCollection();
  const ref = await addDoc(col, createContactMessageDb(parsed, serverTimestamp()));
  return {messageId: ref.id};
}
